import { get } from "lodash";
import tracking from "@irati-tracking/platform";
import errorCodes from "../errorCodes/Onboarding";
import { createOnboarding, resendWelcomeEmail } from "../services/onboarding";
export default function handleOnboardingDoesNotExist(err, user) {
    var createOnboardingOnFail = get(err, "config.createOnboardingOnFail", false);
    var notFound = get(err, "response.data.code") === errorCodes.OnboardingNotFound;
    if (createOnboardingOnFail && notFound) {
        tracking.onBoarding("Step 0");
        return createOnboarding(user).then(function () {
            return resendWelcomeEmail(user);
        });
    }
    throw err;
}
